/**
 * A photo that fails to load: hide the browser's broken-image icon and alt
 * text, so the neutral frame behind it (bg-well / the card tint) shows, the
 * same fallback as the product cards (LuxuryProductCard).
 */
export const hideBrokenImage = (event) => {
  event.currentTarget.style.visibility = 'hidden';
};
